<template>
  <div id="chat-app-container-inner">
    <div class="chat-app-wrapper">
      <chat-tip></chat-tip>
      <chat-modal></chat-modal>
      <chat-start></chat-start>
    </div>
  </div>
</template>

<script>
import ChatStart from '@/components/ChatStart'
import ChatModal from '@/components/ChatModal'
import ChatTip from '@/components/ChatTip'
import { mapState, mapMutations, mapActions } from 'vuex'
import api from './api'

let chatAppSocketStatusTimer = null

export default {
  name: 'App',
  components: {
    ChatStart,
    ChatModal,
    ChatTip,
  },
  created() {
    setInterval(() => {
      this.$remote.$emit('pump', {})
    }, 1000 * 60)
    if (api.production) {
      initAppTimer(this)
    } else {
      this.startApp()
    }
  },
  methods: {
    ...mapActions(['init', 'updateNoAdminOlineStatus']),
    ...mapMutations(['initApp', 'openMessage', 'updateTip', 'updateAppStatus', 'updateWindowUser', 'closeMessage', 'updateSuperAdminOnline']),
    ...mapMutations('chatList', ['getChatList', 'updateChatLastMessage',  'addChat', 'addChatUnread', 'updateChatLastPage', 'updateChatIsEnd', 'updateChatPageLoading', 'getChatPagination']),
    ...mapActions('messageList', ['getMessage', 'initMessage' ]),
    ...mapActions('chatList', ['initChatList' ]),
    ...mapMutations('messageList', ['showMessageLoading', 'updateMessagePage', 'getMessagePagination', 'closeMessagePageLoading', 'updateReply', 'updateMessageUnread' ]),
    startApp(window_user) {

      if ( window_user ) {
        this.updateWindowUser(window_user)
      }

      fetch(`${api.baseUrl}pushMessage`)
        .then(res => res.json())
        .then(res => {
          if (res.status) {
            this.updateTip(res.data)
          }
        })
        .catch(e => console.log(e))
      if (this.user.uuid) {
        this.$remote.$emit('ping', Object.assign({...this.user}, { 
          user_id: window_user ? window_user.user_id : null, 
          email: window_user ? window_user.login : null 
        }))
      } else {
        this.initApp()
      }
    }
  },
  computed: {
    ...mapState(['user', 'tip_object', 'window_user', 'open_message', 'super_admin_online', 'no_admin_online' ]),
    ...mapState('chatList', ['list']),
    ...mapState('messageList', ['admin',]),
  },
  remote: {
    online: function(res) {
      let new_ar = [ { uuid: res.uuid } ].concat(this.super_admin_online)
      this.updateSuperAdminOnline(new_ar)
    },
    exit: function(res) {
      let i = null 
      this.super_admin_online.forEach((ad, index) => {
        if (ad.uuid == res.uuid) i = index
      })

      if ( i !== null ) {
        let new_ar = [].concat(this.super_admin_online)
        new_ar.splice(i, 1)
        this.updateSuperAdminOnline(new_ar)
      }
    },
    ping: function(res) {
      this.init( { user: res.user, server_time: res.server_time } )
      this.updateSuperAdminOnline(res.active_admins || [])
      this.$remote.$emit('getconversations', res.user)
      
      if ( this.tip_object.id ) {
        this.$remote.$emit('marketingmessage', {
          conversation_id: 0,
          to_user_uuid: res.user.uuid,
          data: this.tip_object.content,
          type: 'admin'
        })
      }

      if (!chatAppSocketStatusTimer) {
        chatAppSocketStatusTimer = setInterval( () => this.updateAppStatus(window.CHAT_SOCKET_STATUS), 1000 )
      }
      
      fetch(`${api.baseUrl}/statistical/index/uuid/${res.user.uuid}`)
        .catch(e => console.log(e))
    },
    conversationIsRead: function(res) {
      if ( res.conversation_id == this.admin.conversation_id ) {
        this.updateMessageUnread()
      }
    },
    getconversations: function(res) {
      this.updateChatLastPage(res.last_id)
      this.updateChatIsEnd(res.is_end)

      if ( this.open_message ) {
        this.closeMessage()
      }

      if (!res.conversations.length && !res.is_pagination ) {
        this.initMessage({ admin: {}, list: []})
        this.openMessage()
        return
      }
      if (res.is_pagination) {
        setTimeout(() => {
          res.conversations.length > 0 && this.getChatPagination(res.conversations)
          this.updateChatPageLoading(false)
        }, 1.5 * 1000)
      } else {
        this.initChatList( res.conversations )
      }

    },
    getConversation: function(res) {

      this.updateMessagePage({ last_page: res.last_id, current_page: JSON.parse(res.history).length > 0 ? JSON.parse(res.history)[0].id : 0 })
      if ( res.is_pagination ) {
        this.closeMessagePageLoading()
        JSON.parse(res.history).length > 0 && this.getMessagePagination(JSON.parse(res.history))
        
      } else {
        this.initMessage({ admin: {
          admin_uuid: res.admin_uuid,
          conversation_id: res.conversation_id, 
        }, list: processUrlStringAry(JSON.parse(res.history))})
      }
    },
    message: function(res) {
      processUrlString(res)
      this.getMessage({
        admin: {
          conversation_id: res.conversation_id
        }, 
        message: {
          content: res.data,
          message_type: res.message_type || 'text',
          created_time: res.server_time,
          type: res.type || 'user',
          is_read: res.is_read
        }
      })

      // if (res.is_read == '1') {
      //   this.updateMessageUnread()
      // }

      if (!this.super_admin_online.length && this.no_admin_online ) {
        this.updateNoAdminOlineStatus(false)
        setTimeout( () => {
          this.getMessage(
            {
              message: {
                content: 'Typically reply in 1 hour in working time',
                type: 'user',
                created_time: Date.parse(new Date()),
                message_type: 'warn',
              }
            }
          )
        }, 1.5 * 1000 )
      }

      this.updateReply({ text: '', status: 'done' })
    },
    fromMsg: function(res) {
      processUrlString(res)
      if (res.conversation_id == this.admin.conversation_id) {
        this.getMessage({
          admin: {
            conversation_id: res.conversation_id,
            admin_uuid: res.from_user_uuid
          }, 
          message: {
            content: res.data,
            message_type: res.message_type || 'text',
            created_time: res.server_time,
            type: 'admin'
          }
        })
      }

      let index = null 
      this.list.forEach((l, i) => {
        if (l.id == res.conversation_id) index = i
      })
      if ( index !== null ) {
        if ( !(res.conversation_id == this.admin.conversation_id && this.open_message) ) {
          this.addChatUnread(index)
        }
        this.updateChatLastMessage({
          index: index,
          message: res.data,
          created_time: res.server_time
        })
      } else {
        this.addChat({
          id: res.conversation_id,
          last_message: res.data,
          last_send_time: 'Just now',
          created_time: res.created_time,
          message_type: res.message_type,
        })
      }
    },
    marketingmessage: function(res) {
      window.localStorage.setItem('PCBCART_PUSH_MESSAGE_' + this.tip_object.id, this.tip_object.md5)
      
      this.addChat({
        id: res.conversation_id,
        last_message: res.data,
        last_send_time: 'Just now',
        created_time: res.created_time,
        message_type: res.message_type,
        user_unread_number: 0,
      })

      this.openMessage()
      this.showMessageLoading()
      this.$remote.$emit('getConversation', { conversation_id: res.conversation_id })

    } 
  },
}

let initTimer = null
function initAppTimer(context) {
  initTimer = setInterval(() => {
    if (window.CHAT_APP_INIT) {
      window.CHAT_APP_INIT = false
      context.startApp( window.WINDOW_USER_INFO ? window.WINDOW_USER_INFO : null)
    }

    if (window.WINDOW_USER_INFO) {
      context.startApp(window.WINDOW_USER_INFO ? window.WINDOW_USER_INFO : null)
      clearInterval(initTimer)
    }
  }, 500)
}

function processUrlString(res, singler) {
  let reg =  new RegExp('^(((ht|f)tp(s?))\://)?(www.|[a-zA-Z].)[a-zA-Z0-9\-\.]+\.(com|edu|gov|mil|net|org|biz|info|name|museum|us|ca|uk|cn)(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\;\?\'\\\+&amp;%\$#\=~_\-]+))*$')
  let v = res.data || res.content
  let b_c = null
  if (res.message_type == 'text') {
    let c = reg.exec(v)
    if (!c) return res
    
    if (!c[0].includes('http://') && !c[0].includes('https://')) {
      b_c = `//${c[0]}`
    } else {
      b_c = c[0]
    }
    if ( singler ) {
      res.content = res.content.replace(c[0], `<a class="parse-url" target="blank" href="${b_c}">${c[0]}</a>`)
    } else {
      res.data = res.data.replace(c[0], `<a class="parse-url" target="blank" href="${b_c}">${c[0]}</a>`)
    }
  }

  return res
}

function processUrlStringAry(ress) {
  ress.forEach(r => {
    r = processUrlString(r,  true)
  })
  return ress
}

</script>

<style lang="scss">
html, body {height: 100%;}
#chat-app-container-inner {
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; position: absolute; left: 0; top: 0; right: 0; bottom: 0;
  * {box-sizing: border-box;}
}
.chat-app-wrapper {position: fixed; bottom: 15px; right: 15px;}
</style>


// WEBPACK FOOTER //
// src/App.vue